import type { BaseLoggerMethods, LogContext, LogFunctions } from './logger.types'

export function createLoggerMethods(logFunctions: LogFunctions, defaultContext?: LogContext): BaseLoggerMethods {
  return {
    error: (msg, ctx) => logFunctions.error(msg, { ...defaultContext, ...ctx }),
    warn: (msg, ctx) => logFunctions.warn(msg, { ...defaultContext, ...ctx }),
    info: (msg, ctx) => logFunctions.info(msg, { ...defaultContext, ...ctx }),
    debug: (msg, ctx) => logFunctions.debug(msg, { ...defaultContext, ...ctx }),
  }
}
